import { render, staticRenderFns } from "./WorkDividedInBase.vue?vue&type=template&id=3c8b5932&scoped=true"
import script from "./WorkDividedInBase.vue?vue&type=script&lang=js"
export * from "./WorkDividedInBase.vue?vue&type=script&lang=js"
import style0 from "./WorkDividedInBase.vue?vue&type=style&index=0&id=3c8b5932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8b5932",
  null
  
)

export default component.exports